import React from 'react';
import { Search } from 'lucide-react';

interface ProductSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  totalProducts: number;
}

export function ProductSearch({ searchQuery, onSearchChange, totalProducts }: ProductSearchProps) {
  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Search className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search products..."
          className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-primary focus:border-primary sm:text-sm"
        />
      </div>
      <div className="flex justify-between items-center text-sm text-gray-600">
        <span>
          {totalProducts} product{totalProducts !== 1 ? 's' : ''} found
        </span>
        {searchQuery && (
          <button
            onClick={() => onSearchChange('')}
            className="text-primary hover:text-primary/80"
          >
            Clear search
          </button>
        )}
      </div>
    </div>
  );
}